export default "__VITE_ASSET__BFsm3yzb__"